// ABOUTME: Credit card icon for payment methods UI.
// ABOUTME: Displays a generic card icon with configurable size, color, and className.

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const CreditCardIcon = ({ className = "", size = 20, color = "#6B7280" }: IconProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="5"
      width="20"
      height="14"
      rx="2"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M2 10H22"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M6 14H10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
